import {useCallback, useState} from 'react';
import {message} from 'antd';
import userApi from 'api/userApi';
import {dispatchTokenRefreshed, saveStoredToken} from 'api/http';

/**
 * useLogin
 * - 로그인 API 호출, 토큰 저장, 메시지 처리, 로딩 상태를 관리합니다.
 * - onSuccess/onError/onFinally 콜백으로 상위에서 후속 처리를 연결할 수 있습니다.
 */
export default function useLogin({ onSuccess, onError, onFinally } = {}) {
  const [loading, setLoading] = useState(false);

  const login = useCallback(async (values) => {
    setLoading(true);
    try {
      const response = await userApi.login(values);
      message.success('로그인이 완료되었습니다.');

      const data = response?.data?.data;
      if (data) {
        saveStoredToken(data);
        dispatchTokenRefreshed(data);
      }

      if (onSuccess) onSuccess(data);
      return data;
    } catch (error) {
      console.error('로그인 실패:', error);
      // 에러 토스트는 공통 인터셉터에서 처리
      if (onError) onError(error);
      throw error;
    } finally {
      setLoading(false);
      if (onFinally) onFinally();
    }
  }, [onSuccess, onError, onFinally]);

  return { login, loading };
}
